var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEpubIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2762 0H4.32736C3.59507 0 3 0.599733 3 1.3416V22.6584C3 23.3995 3.59507 24 4.32736 24H20.2591C20.993 24 21.5865 23.3995 21.5865 22.6584V5.3664L16.2762 0ZM16.2762 1.8968L19.7097 5.3664H16.2762V1.8968ZM20.2594 22.6584H4.32736V1.3416H14.9486V5.3664C14.9486 6.10747 15.5424 6.708 16.276 6.708H20.2591L20.2594 22.6584Z",
    fill: "#0E9948"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12436_10949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9921 8.00964C11.8024 8.00964 11.6427 8.07453 11.5129 8.20432L6.19687 13.5054C6.06709 13.6451 6.0022 13.8099 6.0022 13.9995C6.0022 14.1892 6.06709 14.3489 6.19687 14.4787L11.5129 19.7798C11.6427 19.9195 11.8024 19.9894 11.9921 19.9894C12.1818 19.9894 12.3415 19.9195 12.4713 19.7798L17.7873 14.4787C17.9171 14.3489 17.982 14.1892 17.982 13.9995C17.982 13.8099 17.9171 13.6451 17.7873 13.5054L17.0086 12.7417L11.9921 17.7582L8.23343 13.9995L11.9921 10.2259L13.25 11.4838L10.7342 13.9995L11.9921 15.2424L15.7507 11.4838L12.4713 8.20432C12.3415 8.07453 12.1818 8.00964 11.9921 8.00964Z",
    fill: "#0E9948"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12436_10949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEpubIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/epub-icon.118dee8097eaf895e6b8f6b25b4cb71e.svg";